export { type AuthoredDocumentPdfData } from './types'
export { AuthoredDocumentPdfGenerator } from './AuthoredDocumentPdfGenerator'

import type { AuthoredDocumentPdfData } from './types'
import { AuthoredDocumentPdfGenerator } from './AuthoredDocumentPdfGenerator'

/** Generate (and download) a chat-authored document as a PDF — MYAC-1162. */
export function generateAuthoredDocumentPdf(data: AuthoredDocumentPdfData, filename: string): void {
  new AuthoredDocumentPdfGenerator(data).generate(filename)
}
